import React from "react";
import { publicCountryImage } from "@/lib/countryImage";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";

export default function Countries() {
  const { t } = useTranslation();
  const { data: countries = [] } = useQuery({ queryKey: ["countries"], queryFn: async () => (await api.get("/countries")).data });
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="overline mb-4">{t("nav.countries", "Destinations")}</div>
      <h1 className="font-serif text-5xl md:text-6xl text-zinc-950 tracking-tight max-w-4xl">{t("countries.title", "Destinations we serve")}</h1>
      <p className="mt-6 text-lg text-zinc-900 max-w-3xl">{t("countries.subtitle")}</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
        {countries.map((c) => (
          <Link key={c.id} to={`/countries/${c.id}`} className="group relative rounded-3xl overflow-hidden aspect-[4/5] block card-lift" data-testid={`country-${c.code}`}>
            <img src={publicCountryImage(c)} alt={c.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/40 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 text-white">
              <div className="overline text-[#d4a017] mb-2">{c.code}</div>
              <div className="font-serif text-3xl mb-2">{c.name}</div>
              <p className="text-sm text-zinc-300 leading-relaxed line-clamp-3">{c.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
